export default "__VITE_ASSET__BsDvWj0m__"